<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :search.sync="search"
               :data="data"
               :page.sync="page"
               v-if="reWrite"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menuLeft">
<!--        <el-button type="danger"-->
<!--                   size="small"-->
<!--                   icon="el-icon-delete"-->
<!--                   plain-->
<!--                   v-if="permission.warehousestock_delete"-->
<!--                   @click="handleDelete">删 除-->
<!--        </el-button>-->
        <div style="display:flex;align-items: center;">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="exportExcel"
        >导出
        </el-button><div class="pan-item-content">在库数量:{{totalNum}}     总金额:{{tool.money_format_allowvoid(totalAmount)}}</div>
        </div>
      </template>

      <template slot="projectIdSearch">
        <el-select
          v-model="projectName"
          @change="searchProjectChange"
          placeholder="项目名称"
        >
          <el-option
            v-for="item in projectList"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="price" slot-scope="scope">
              <div class="money"><span>{{tool.money_format_allowvoid(scope.row.price)  }}</span></div>
            </template>
            <template slot="subtotalAmount" slot-scope="scope">
              <div class="money"><span>{{tool.money_format_allowvoid(scope.row.subtotalAmount)  }}</span></div>
            </template>
      <template slot="warehouseIdSearch">
        <el-select
          v-model="warehouseName"
          placeholder="仓库名称"
          @change="searchWarehouseChange"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="typeIdSearch">
        <el-select v-model="typeName" placeholder="物品类型" >
          <el-option>
            <el-tree :data="typeData"
                     :props="defaultProps"
                     @node-click="handleNodeClick">


            </el-tree>
          </el-option>

        </el-select>




      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update,selectStockSum} from "@/api/crmedical/warehouse/warehousestock";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {getWarehouseList} from "@/api/crmedical/warehouse/warehouse";
  import {getToken} from '@/util/auth';
  import {treeFree} from "@/api/crmedical/warehouse/warehouseconsumabletype";

  export default {
    data() {
      return {
        form: {},
        search: {},
        projectName: '',
        totalNum:'',
        totalAmount:'',
        warehouseName:'',
        query: {},
        typeName:'',
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        typeData:[],
        defaultProps: {
          value:'id',
          children: 'children',
          label: 'name'
        },
        projectList: [],
        warehouseList:[],
        selectionList: [],
        reWrite: false,
        option: {
          height: 'auto',
          calcHeight: 50,
          tip: false,
          border: true,
          indexLabel: '序号',
          index: true,
          viewBtn: false,
          delBtn: false,
          addBtn:false,
          editBtn:false,
          menu:false,
          selection: true,
          columnBtn: false,
          refreshBtn: false,
          searchMenuSpan: 24,
          
          stripe:true,
          column: [

            {
              label: "项目名称",
              prop: "projectId",
              type: 'tree',
              hide: false,
              searchslot: true,
              span: 12,
              searchClearable: false,
              editDisabled: true,
              search: true,
              dicUrl: '/api/v4ward/project/getProjectList',
              props: {label: 'name', value: 'id'},
              rules: [
                {
                  required: true,
                  message: "请选择项目",
                  trigger: "change"
                }
              ]
            },
            {
              label: "仓库名称",
              prop: "warehouseId",
              type: 'tree',
              hide:true,
              searchslot: true,
              search: true,

            },

            {
              label: "物品类型",
              prop: "typeId",
              type: 'tree',
              hide: true,
              //dicUrl: 'api/v4ward/warehouse/consumable/type/tree',
              searchslot: true,
              search: true,

            },
            {
              label: "仓库名称",
              prop: "warehouseName",
              hide: true,
              search: false,

            },
            {
              label: "物品",
              prop: "consumableName",
              hide: false,
              search: true,

            },
            {
              label: "编号",
              prop: "code",
              hide: false,
              search: false,

            },
            {
              label: "类型",
              prop: "typeName",
              hide: false,
              search: false,
            },
            {
              label: "品牌",
              prop: "brand",
              hide: false,
              search: false,
            },
            {
              label: "规格",
              prop: "specification",
              hide: false,
              search: false,
            },
            {
              label: "生产商",
              prop: "manufacturer",
              hide: false,
              search: false,
            },
            {
              label: "计量单位",
              prop: "measuringUnitName",
              hide: false,
              search: false,
            },
            {
              label: "库存数量",
              prop: "stockNum",
              hide: false,
              search: false,
            },
            {
              label: "出库单价",
              prop: "price",
              hide: false,
              search: false,
              align: 'right',
              slot:true
            },
            {
              label: "小计金额",
              prop: "subtotalAmount",
              hide: false,
              search: false,
              align: 'right',
              slot:true
            },

          ]
        },
        data: [],
        onloadFlag:false,
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.warehousestock_add, false),
          viewBtn: this.vaildData(this.permission.warehousestock_view, false),
          delBtn: this.vaildData(this.permission.warehousestock_delete, false),
          editBtn: this.vaildData(this.permission.warehousestock_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created() {
      //加载项目列表
      getProjectList({}).then((res) => {
        this.projectList = res.data;
        this.projectName = this.projectList[0].name;
        this.query.projectId = this.projectList[0].id;
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
        }
        treeFree({projectId:this.query.projectId}).then((res) => {
          this.typeData = res.data;
        });
        getWarehouseList({projectId:this.query.projectId}).then((res) => {

            console.log("1111111111111111111")
            this.warehouseList = res.data;
            console.log(res.data)
            this.warehouseName = this.warehouseList[0]?this.warehouseList[0].name:'';
            this.query.warehouseId = this.warehouseList[0]?this.warehouseList[0].id:'';
            if (this.warehouseList.length > 0) {
              this.query.warehouseId = this.warehouseList[0].id;

            }
            this.onLoad()

        });

        this.$nextTick(() => {
            this.reWrite = true;
            setTimeout(()=>{
              this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{
                    
                    if(this.option.height == this.bodyHeight - 398){
                      this.option.height = this.bodyHeight - 280
                    }else{
                      this.option.height = this.bodyHeight - 398;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
        
        });
        this.option.height = this.bodyHeight - 398;
      });
    },

    methods: {

      exportExcel(){
        this.$confirm("是否导出库存数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出数据
          let projectId = '';
          if (this.query.projectId) {
            projectId = this.query.projectId;
          }
          let warehouseId = '';
          if (this.query.warehouseId) {
            warehouseId = this.query.warehouseId;
          }
          let typeId = '';
          if (this.query.typeId) {
            typeId = this.query.typeId;
          }

          let consumableName = '';
          console.log(this.query.consumableName)
          if (this.query.consumableName) {
            consumableName = this.query.consumableName;

          }
          window.open(`/api/v4ward/warehouse/stock/export?${this.website.tokenHeader}=${getToken()}&projectId=${projectId}&warehouseId=${warehouseId}&typeId=${typeId}&consumableName=${consumableName}`);
        });
      },

      handleNodeClick(node){
        console.log(node)
        this.typeName = node.name;
        this.query.typeId = node.id;
        console.log(node)
      },

      searchWarehouseChange(e){
        this.query.warehouseId=e;
      },

      searchProjectChange(e) {
        this.warehouseName='';
        this.typeName='';
        this.query.projectId = e;
        //加载仓库列表
        getWarehouseList({projectId:e}).then((res) => {
          this.warehouseList = res.data;
          this.warehouseName = this.warehouseList[0].name;
          this.query.warehouseId = this.warehouseList[0].id;
          if (this.warehouseList.length > 0) {
            this.query.warehouseId = this.warehouseList[0].id;
          }


        });
        treeFree({projectId:this.query.projectId}).then((res) => {
          if (this.vdui.isNotEmpty(res.data)) {
            this.typeData = res.data;
          }else {
            this.typeData =[""];
          }
          this.$nextTick(() => {
            this.reWrite = true;
          });

        });
      },

      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        } else if ("add" === type) {
          this.cleanForm();
        }
        done();
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },
      searchReset() {
        this.typeName='';
        this.query.typeId='';
        this.query.consumableName='';
        this.onLoad();
      },
      searchChange(params, done) {
        this.query.projectId=this.query.projectId;
        this.query.warehouseId=this.query.warehouseId;
        this.query.typeId=this.query.typeId;
        this.query.consumableName=params.consumableName;
        console.log(this.query)
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        if(!this.onloadFlag){
          this.onloadFlag = true
          return;
        }
        page = page || this.page;
        this.loading = true;
        //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区

        if (!this.query.projectId) {
          this.query.projectId = this.query.projectId;
        }

        if (!this.query.warehouseId) {
          this.query.warehouseId = this.query.warehouseId;
        }
        selectStockSum(this.query).then((res) => {
          this.totalNum = res.data.totalNum;
          this.totalAmount=res.data.totalAmount;

        });
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        })
      }
    }
  };
</script>

<style scoped>
  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
  ::v-deep .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
  
</style>
<style >
#warehouseconsumable .el-table .cell{
    white-space: inherit;
  }
</style>
